var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiTableCell from '@material-ui/core/TableCell';
/**
 * Kareo wrapped component of the Material-UI TableCell. The prop API has been limited to props defined in TableCellProps.
 *
 * Material-UI TableCell: [Docs](https://v4.mui.com/components/tables/), [API](https://v4.mui.com/api/table-cell/)
 *
 * @storybook: [Table](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-table--table-main-story)
 */
var TableCell = React.forwardRef(function (props, ref) { return (React.createElement(MuiTableCell, __assign({}, props, { ref: ref }))); });
TableCell.displayName = 'KareoTableCell';
export default TableCell;
